import { FC, useEffect, useState } from 'react'
import { ConfirmationModal } from 'featureSliced/features/ConfirmationModal'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type PaymentFailedProps = {
  onCloseModal: (orderGuid?: string) => void
}

// TODO: Component is used as PaymentCanceled. Consider renaming
export const PaymentFailed: FC<PaymentFailedProps> = ({ onCloseModal }) => {
  const t = useTranslations()
  const [animation, setAnimation] = useState<any>(null)
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)

  useEffect(() => {
    import(`assets/lotties/${appTheme}/failedOrder.json`)
      .then((animation) => {
        setAnimation(animation.default)
      })
      .catch((err) => {
        console.error('Failed to load smiley animation', err)
      })
  }, [])

  return (
    <ConfirmationModal
      text={t('receipt.paymentUnsuccess')}
      onConfirm={onCloseModal}
      animationJSON={animation}
    />
  )
}
